// extracted by mini-css-extract-plugin
export default {"container":"loader_container__slsq-","wrapper":"loader_wrapper__BS5Gl"};